import React from "react"
import PropTypes from "prop-types"
import { Slideshow, Tabs } from "components"
import {
  getImageSrcBasedOnOptions,
  ConfiguredVehicle,
} from "containers"
import { ImagesRotator, Disclaimer } from 'AtomicContainers'
import { H5, Caption, LoadingIcon, StarIcon, A, Content, Space, H4 } from 'AtomicComponents'
import { Radium } from "higher-order-components"

const descriptionText = description =>
  description && (
    <p style={styles.description} data-test="description">
      {description}
    </p>
  )

const RenderConfiguredVehicleCompact = ({
  display360,
  step,
  isSelectColorInterior,
  options,
  onChange,
  price,
  safetyModel,
  includeSafetyModel,
  finance,
  showDescription
}) => {
  if (!step.radioGroup) return null
  const activeOption = options[step.radioGroup[0].itemName]
  const activeGroup = options[step.radioGroup[0].groupName]
  const activeIndex = activeGroup.indexOf(activeOption)
  const imageSrc = getImageSrcBasedOnOptions(
    display360,
    options,
    activeOption,
    step,
    isSelectColorInterior
  )
  return (
    <div style={{ padding: "15px" }} data-test="compact-vehicle">
      {activeOption.name && <H4 withDetails>{activeOption.name}</H4>}
      <Space />
      {step.radioGroup.map((radio, index) => {
        const props = {
          onChange: onChange,
          options: options[radio.groupName],
          active: options[radio.groupName].indexOf(options[radio.itemName]),
          only: options[radio.groupName].length <= 1
        }
        if (index !== 0) {
          return <Tabs key={index} divider {...props} />
        }
      })}
      <Slideshow
        showBullets
        activate={activeIndex}
        bulletsBelow
        handleChange={(index) => {
          onChange(activeGroup[index])
        }}>
        {activeGroup.map((option, index) => (
          <div key={index} style={styles.slideshowItem}>
            {Array.isArray(imageSrc) && display360 ? (
              <ImagesRotator imagesSrc={imageSrc} />
            ) : (
              <ConfiguredVehicle
                isFadeAnimation
                key={index}
                src={option.imageMobileSrc || imageSrc} />
            )}
          </div>
        ))}
      </Slideshow>
      <Space />
      <div style={[
        { boxSizing: "border-box", overflow: "hidden", textAlign: "left" },
        step.features && options.grade.features ? { width: "100%" } : { height: 0, width: "0" }
      ]}>
        <div style={styles.feature}>
          <H5 withDetails>{options.grade.name}</H5>
          {
            price && price.price && price.disclaimer ?
              <A
                withoutStyle
                onClick={(event) => {
                  if (event && event.target && event.target.querySelector('button')) {
                    event.target.querySelector('button').click()
                  }
                }}>
                <Caption>From</Caption> <span style={{ fontSize: "20px" }}>${includeSafetyModel ? price.safetyModelPrice.toLocaleString() : price.price.toLocaleString()}</span>
                <Disclaimer Icon={StarIcon}>
                  {price.disclaimer}
                </Disclaimer>
              </A>
              : <LoadingIcon
                style={{
                  width: "16px",
                  height: "16px"
                }}
              />
          }
        </div>
        {
          options.engine.safetyModelCode &&
          safetyModel
        }
        <Space />
        <Content textAlign="left">
          <label><b>
            {
              options.grade.featuresHeading ?
              options.grade.featuresHeading :
              (options.grades.length === 1 ||
                options.grades.indexOf(options.grade) === 0 ||
                options.grades.length === ((options.grades.indexOf(options.grade)) - 1)) ?
                "Base features:" :
                `In addition to ${options.grades[options.grades.indexOf(options.grade) - 1].name}:`
            }
          </b></label>
          <ul>
            {options.grade.features.map((item, index) => (
              <li
                key={`Featuer-${index}`}>
                <Caption>{item.description}</Caption>
              </li>
            ))}
          </ul>
          {
            finance && (
              <div style={styles.financeOption}>
                <img
                  style={styles.financeIcon}
                  src={finance.icon} />
                <Caption>
                  {finance.description}
                </Caption>
              </div>
            )
          }
        </Content>
      </div>
      <Space />
      {showDescription ? descriptionText(activeOption.description) : ""}
    </div>
  )
}

RenderConfiguredVehicleCompact.propTypes = {
  display360: PropTypes.bool,
  step: PropTypes.object,
  isSelectColorInterior: PropTypes.bool,
  options: PropTypes.object,
  onChange: PropTypes.func,
  currentPriceArray: PropTypes.array,
  showDescription: PropTypes.bool
}

export default Radium(RenderConfiguredVehicleCompact)

const styles = {
  slideshowItem: {
    maxWidth: "90%",
    margin: "0 auto"
  },
  description: {
    textAlign: "center",
    margin: "0 0 1em 0",
    color: "#101010",
    fontWeight: "300",
    lineHeight: "1.5"
  },
  feature: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e7e7e7",
    minHeight: "44px"
  },
  financeOption: {
    display: 'flex',
    marginTop: '18px',
    alignItems: 'center',
  },
  financeIcon: {
    marginRight: '10px',
    width: '15px'
  }
}



// WEBPACK FOOTER //
// ./src/containers/configured-vehicle-selector/render-config-vehicle-compact.jsx